import { Lock } from "lucide-react";

// Bandeau « en cours d'utilisation » affiché quand un autre utilisateur détient le verrou
export const LockBanner = ({ message, className = "" }) => {
  if (!message) return null;
  return (
    <div className={`flex items-center gap-3 p-4 rounded-sm border-2 border-orange-400 bg-orange-50 text-orange-900 ${className}`} role="alert" data-testid="lock-banner">
      <Lock className="w-6 h-6 shrink-0" />
      <div>
        <p className="font-bold">{message}</p>
        <p className="text-xs mt-0.5">Lecture seule : attendez que cet utilisateur ferme le document, puis rouvrez-le.</p>
      </div>
    </div>
  );
};
